import React, { useState, createContext } from 'react'
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const ReactSwal = withReactContent(Swal)

const SETTING = {
    APP_FULLSCREEN: true,
    DEFINES: {
        'PRIMARY_COLOR': '#22e193',
        'SECONDARY_COLOR': '#08d258',
    },
    COMPONENTS: {
        TabScreen: {
            ACTIVE_TAB_COLOR: 'PRIMARY_COLOR'
        }
    }
}

export const BodyContext = createContext();
export const BodyProvider = props => {
    const [classing, set_classing] = useState({});
    const [options, _set_options] = useState(SETTING);
    const [overpage, set_overpage] = useState(null);
    const set_options = (everything) => {
        _set_options({
            ...options,
            ...everything
        })
    }
    const [authRedirection, set_authRedirection] = useState();
    const statics = {
        images: {
            brand: {
                logo_shape_color: null,
                logo_type_black: null,
            }
        }
    };
    let CT = {
        classing,
        set_classing,
        // 
        options,
        set_options,
        // 
        authRedirection,
        set_authRedirection: function (mode, route) {
            mode === 'LOGOUT' && set_authRedirection(<Redirect to='/login' />)
            mode === 'LOGIN' && set_authRedirection(<Redirect to='/dashboard' />)
            mode === 'MANUAL' && set_authRedirection(<Redirect to={route} />)
            mode === 'DELETE' && set_authRedirection(null)
        },
        popup: {
            open: (mode, data) => {
                return new Promise((resolve, reject) => {
                    let initialData = {
                        title: <div className="swal--head">{data.title || 'title'}</div>,
                        icon: mode ? mode.toLowerCase() : null
                    }
                    ReactSwal.fire({
                        ...initialData,
                        showCloseButton: true,
                        focusConfirm: true,
                        focusCancel: false,
                        focusDeny: false,
                        html: <>
                            <div className="swal--content">
                                {data.body || ''}
                            </div>
                        </>,
                        customClass: {
                            container: 'swal',
                            popup: 'swal-box',
                            title: 'swal--title',
                            closeButton: 'swal-closebtn',
                            denyButton: 'swal-denybtn',
                            confirmButton: 'Btn -force',
                            cancelButton: '',
                        },
                        ...data.modify || null
                    })
                        .then(res => {
                            if (res.isConfirmed) {
                                resolve(true)
                            } else if (res.isDenied) {
                                reject('DENY')
                            }
                        })
                        .catch(err => {
                            reject('CANCEL')
                        })
                })
            },
            confirm: () => ReactSwal.clickConfirm(),
            deny: () => ReactSwal.clickDeny(),
            cancel: () => ReactSwal.clickCancel(),
        },
        statics,
        // 
        overpage,
        set_overpage,
        // 
    }
    return (
        <BodyContext.Provider value={[CT]}>
            {props.children}
        </BodyContext.Provider>
    )
}